<template>
  <div class="reject-reason-picker">
    <p v-if="label" class="reject-reason-picker__label">{{ label }}</p>
    <div class="reject-reason-picker__chips" role="group" :aria-label="label">
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="reject-reason-picker__chip"
        :class="{ 'reject-reason-picker__chip--selected': modelValue === option.value }"
        :aria-pressed="modelValue === option.value"
        @click="select(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
    <p v-if="error" class="reject-reason-picker__error">{{ error }}</p>
  </div>
</template>

<script>
  export default {
    name: 'RejectReasonPicker',
    props: {
      modelValue: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        required: true,
      },
      label: {
        type: String,
        default: '',
      },
      error: {
        type: String,
        default: '',
      },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const select = (value) => {
        emit('update:modelValue', value);
      };

      return { select };
    },
  };
</script>

<style scoped lang="scss">
  .reject-reason-picker {
    &__label {
      margin: 0 0 0.5rem;
      font-size: 0.875rem;
      font-weight: 500;
      color: var(--slate-700);
    }

    &__chips {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
    }

    &__chip {
      appearance: none;
      margin: 0;
      padding: 0.4375rem 0.75rem;
      border: 1px solid var(--slate-200);
      border-radius: 999px;
      background: var(--white, #fff);
      color: var(--slate-700);
      font-size: 0.8125rem;
      font-weight: 500;
      line-height: 1.25;
      cursor: pointer;
      transition:
        background-color 160ms ease-out,
        border-color 160ms ease-out,
        color 160ms ease-out;

      @include hover {
        border-color: var(--slate-300);
        background-color: var(--slate-50);
      }

      &--selected {
        border-color: var(--cs-button-default-background, var(--brand-600));
        background-color: var(--brand-50);
        color: var(--brand-700);
      }
    }

    &__error {
      margin: 0.5rem 0 0;
      font-size: 0.8125rem;
      color: var(--red-600);
    }
  }
</style>
